import { apiRequest } from './client';
import {
  setAdminSessionToken,
  setClientSessionToken,
  setLocalSessionToken,
} from './authToken';
import { notifyStaffAuthChanged } from '../auth/appAuth';
import { notifyClientAuthChanged } from '../auth/clientAppAuth';
import { notifyAdminAuthChanged } from '../admin-panel/admin-auth/adminAppAuth';

export async function loginWithPassword(email, password) {
  const data = await apiRequest('/api/auth/login', {
    method: 'POST',
    body: { email, password },
  });
  if (data?.token) {
    setLocalSessionToken(data.token);
    notifyStaffAuthChanged();
  }
  return data;
}

export async function loginClientWithPassword(email, password) {
  const data = await apiRequest('/api/auth/client/login', {
    method: 'POST',
    body: { email, password },
  });
  if (data?.token) {
    setClientSessionToken(data.token);
    notifyClientAuthChanged();
  }
  return data;
}

export async function loginAdminWithPassword(email, password) {
  const data = await apiRequest('/api/admin/auth/login', {
    method: 'POST',
    body: { email, password },
  });
  if (data?.token) {
    setAdminSessionToken(data.token);
    notifyAdminAuthChanged();
  }
  return data;
}

export async function registerSession({ email, password, kind = 'staff', firstName, lastName }) {
  const data = await apiRequest('/api/auth/register-session', {
    method: 'POST',
    body: { email, password, kind, firstName, lastName },
  });
  if (data?.token) {
    if (kind === 'client') {
      setClientSessionToken(data.token);
      notifyClientAuthChanged();
    } else {
      setLocalSessionToken(data.token);
      notifyStaffAuthChanged();
    }
  }
  return data;
}

export async function changePassword({ currentPassword, password, token }) {
  return apiRequest('/api/auth/password', {
    token,
    method: 'POST',
    body: { currentPassword, password },
  });
}

export async function consumePasswordReset({ token, password }) {
  return apiRequest('/api/auth/password-reset/consume', {
    method: 'POST',
    body: { token, password },
  });
}

export async function consumeAdminPasswordReset({ token, password }) {
  return apiRequest('/api/admin/auth/password-reset/consume', {
    method: 'POST',
    body: { token, password },
  });
}

export async function createTestAccount(payload, { persistSession = false } = {}) {
  const data = await apiRequest('/api/dev/test-accounts', {
    method: 'POST',
    body: payload,
  });
  if (persistSession && data?.token) setLocalSessionToken(data.token);
  return data;
}
